export const TendersRoutes = {
    tenders: (origin: string) => `${origin}/tender-board/tenders`,
    tendersFilters: (origin: string) => `${origin}/tender-board/filters`,
};
